// eslint-disable-next-line no-shadow
const STATUS_LABELS: Record<string, string> = {
  AGUARDANDO_ATENDIMENTO: 'Aguardando Atendimento',
  REQUER_COMPLEMENTO: 'Requer Complemento',
  COMPLEMENTO_ENVIADO: 'Complemento Enviado',
  EM_ATENDIMENTO: 'Em Atendimento',
  DEFERIDO: 'Deferido',
  INDEFERIDO: 'Indeferido',
};

const ROLE_LABELS: Record<string, string> = {
  ANALISTA: 'Analista',
  COLABORADOR: 'Colaborador',
};

export function getStatusLabel(status: string): string {
  return STATUS_LABELS[status] || status.replace(/_/g, ' ');
}

export function getRoleLabel(role: string): string {
  return ROLE_LABELS[role] || role.replace(/_/g, ' ');
}

const DEFAULT_TAG_COLOR = { background: 'rgba(145, 216, 246, 0.25)', text: '#004186' };

const STATUS_COLORS: Record<string, { background: string; text: string }> = {
  AGUARDANDO_ATENDIMENTO: DEFAULT_TAG_COLOR,
  EM_ATENDIMENTO: { background: '#FCFAC4', text: '#6C6A20' },
  REQUER_COMPLEMENTO: { background: '#F5ECE3', text: '#886B4D' },
  COMPLEMENTO_ENVIADO: { background: '#FCFAC4', text: '#6C6A20' },
  DEFERIDO: { background: '#DFF6E9', text: '#31734D' },
  INDEFERIDO: { background: '#FBDDDD', text: '#9D3A3A' },
};

export function getStatusColor(
  status: string,
): { background: string; text: string } {
  if (STATUS_COLORS[status]) return STATUS_COLORS[status];

  const rawKey = Object.keys(STATUS_LABELS).find(
    (key) => STATUS_LABELS[key] === status,
  );
  if (rawKey && STATUS_COLORS[rawKey]) return STATUS_COLORS[rawKey];

  return DEFAULT_TAG_COLOR;
}
